import { useEffect } from 'react';
import { useFormikContext } from 'formik';

const FocusError = ({ setEmployeeTab, setAccordion, errorKeys, employeeTab, accordion }) => {
  const { errors, isSubmitting, isValidating } = useFormikContext();

  useEffect(() => {
    if (isSubmitting && !isValidating && Object.entries(errors).length) {
      const errorsCollection = [...document.getElementsByClassName('is-invalid')];
      errorsCollection.forEach((_value, key) => {
        errorsCollection[key].tabIndex = `error-${key}`;
      });
      if (errorsCollection.length === 0) return;

      const errorKey = errors?.employee ? Object.keys(errors.employee)[0] : null;

      if (employeeTab) {
        const employeesTab =
          errorKey === 'contract' || errorKey === 'employeePrevisionAttributes' ? 'contract' : 'profile';
        setEmployeeTab(employeesTab);
      }

      if (accordion) {
        // --- FORMULARIO DE EMPLEADO ---
        const personalData = [
          'name',
          'firstLastName',
          'identificationType',
          'nationalIdentification',
          'birthdate',
          'countryId',
          'genderId'
        ];
        let accordionKey = '';
        personalData.some(element => {
          if (element === errorKey) {
            accordionKey = 'profile';
            setAccordion(accordionKey);
            return true;
          }
          return false;
        });

        const contactKeys = ['email', 'address', 'regionId', 'communeId'];
        if (errorKeys.some(key => contactKeys.includes(key))) {
          setAccordion('contact');
        }

        if (errors.employee?.contract !== undefined) {
          const contractErrors = Object.keys(errors.employee.contract);

          const contractKeys = [
            'jobManagementId',
            'branchOfficeIds',
            'subsidiaryId',
            'costCenterIds',
            'contractCostCentersAttributes',
            'jobTitleId',
            'contractType',
            'startDate',
            'endDate',
            'parentId',
            'workerQuality',
            'syndicateId',
            'documentTemplateId',
            'incomeTaxType',
            'cityId',
            'extremeZoneAssignment',
            'extremeZoneVacationBenefit',
            'privateRole',
            'outSourced',
            'outSourceNationalIdentification',
            'outSourceBusinessName',
            'outSourceEstablishmentName',
            'outSourceEmail',
            'outSourceAddress',
            'outSourceAddressNumber',
            'outSourceAddressFlat',
            'outSourceAddressOffice',
            'outSourceRegionId',
            'outSourceCommuneId',
            'outSourceExceptionalSystem',
            'outSourceExceptionalSystemNumber'
          ];
          if (errorKeys.includes('contract') || contractErrors.some(key => contractKeys.includes(key))) {
            setAccordion('contract');
          }

          const journeyKeys = [
            'workSchedule',
            'weeklyHours',
            'dailyWorkingHours',
            'agreedDays',
            'monday',
            'tuesday',
            'wednesday',
            'thursday',
            'friday',
            'saturday',
            'sunday',
            'errorDays',
            'workStartTime',
            'workEndTime',
            'checkAssistance',
            'presenceCheckAssistance',
            'markingTypeIds',
            'shiftIds',
            'runningWeek',
            'telecommuting',
            'workScheduleArt27',
            'vacationCalculationArticle67'
          ];
          if (contractErrors.some(key => journeyKeys.includes(key))) {
            setAccordion('journey');
          }

          const benefitsKeys = [
            'additionalHolidays',
            'additionalHolidaysStartDate',
            'acumulativeAdditionalHolidays',
            'administrativeDays',
            'administrativeStartDate',
            'acumulativeAdministrative',
            'recognizedMonths',
            'recognizedMonthsFrom',
            'progressiveVacationsCertificate'
          ];
          if (contractErrors.some(key => benefitsKeys.includes(key))) {
            setAccordion('benefits');
          }

          const salaryKeys = [
            'parsedSalary',
            'salary',
            'paymentSchedule',
            'paymentType',
            'bankId',
            'bankAccount',
            'bankAccountType',
            'gratificationType',
            'gratificationPeriod',
            'gratificationCondition',
            'rima',
            'rimaDate',
            'contractBalancesAttributes',
            'contractBalancesRetentionsAttributes'
          ];
          if (contractErrors.some(key => salaryKeys.includes(key))) {
            setAccordion('salary');
          }

          const previsionKeys = [
            'employeePrevisionAttributes',
            'foreignTechnician',
            'disability',
            'disabilityNationalIdentification',
            'disabilityCertificate'
          ];
          if (contractErrors.some(key => previsionKeys.includes(key))) {
            setAccordion('prevision');
          }

          const familyKeys = [
            'familyGroupsAttributes',
            'chargeType',
            'relationType',
            'name',
            'firstLastName',
            'secondLastName',
            'identificationType',
            'nationalIdentification',
            'countryId',
            'birthdate',
            'genderId',
            'chargeStartDate',
            'chargeEndDate',
            'familyAllowanceSection',
            'observation',
            'chargeNumber'
          ];

          if (contractErrors.some(key => familyKeys.includes(key))) {
            setAccordion('family');
          }
        }

        if (errors.company) {
          const companySections = {
            '0': [
              'nationalIdentification',
              'businessName',
              'fantasyName',
              'economicActivityId',
              'workActivity',
              'website',
              'logo'
            ],
            '1': [
              'address',
              'addressNumber',
              'addressFloor',
              'addressOffice',
              'regionId',
              'communeId',
              'email',
              'phone',
              'phoneCountryCode'
            ],
            '2': ['representantsAttributes'],
            '3': ['bankAccountsAttributes'],
            '4': [
              'safetyOrganizationId',
              'mutualRateBasic',
              'mutualRateExtraordinary',
              'sannaLaw',
              'compensationFundId',
              'adherentNumber',
              'yearOfAgreement'
            ]
          };

          for (const [sectionKey, fields] of Object.entries(companySections)) {
            if (errorKeys.some(key => fields.includes(key))) {
              setAccordion(sectionKey);
              break;
            }
          }
        }
      }

      setTimeout(() => errorsCollection[0]?.focus(), 100);
    }
  }, [isSubmitting, isValidating, errors, accordion, employeeTab, errorKeys, setAccordion, setEmployeeTab]);

  return null;
};

export default FocusError;
